<div class="bg-primary-500 border-primary-300 flex w-full flex-row items-center gap-2 rounded-xl border p-2">
  <image
    [url]="escuderiaAvatar()"
    [alt]="escuderiaName()"
    class="size-12 md:size-14" />
  <div class="w-full">
    <p class="preset-title-6 md:preset-title-5 text-white">Escudería <span class="uppercase">{{ escuderiaName() }}</span></p>
    @if(agenciaName()) {
    <p class="bg-primary-300 preset-body-4 md:preset-body-3 rounded-full px-2 py-1 text-white">{{ agenciaName() }}</p>
    }
  </div>
</div>
